import styled from 'styled-components';

import { CloseCircleIc } from '@dsch/dd-icons';

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ErrorIcon = styled(CloseCircleIc)`
  height: 64px;
  width: 64px;
  color: ${({ theme }) => theme.colors.RED};
`;

export { Container, ErrorIcon };
